/**
 * ConfirmDialog
 * A modal dialog that asks for user confirmation before a destructive action.
 */

import { Modal } from './Modal';
import { StudioButton } from './StudioButton';
import { useUIStore } from '@atlas-forms/state-react';

export interface ConfirmDialogProps {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'danger' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  isOpen,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { theme } = useUIStore();
  const isDark = theme === 'dark';

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} width={400}>
      <p style={{ color: isDark ? '#cbd5e1' : '#374151', marginBottom: '24px', fontSize: '14px' }}>{message}</p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <StudioButton variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </StudioButton>
        <StudioButton
          variant={confirmVariant === 'danger' ? 'danger' : 'primary'}
          onClick={onConfirm}
        >
          {confirmLabel}
        </StudioButton>
      </div>
    </Modal>
  );
}
